export default "__VITE_ASSET__DQxnskiM__"